import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { showSubmit } from "../../../data/booking/actions/booking";
import {
    getShowSubmit,
    getIsSubmitting,
    getIsSavingDraft,
} from "../../../data/booking/selectors/booking";
import SubmitButton from "../../booking/components/SubmitButton";

class SubmitButtonContainer extends Component {
    static propTypes = {
        data: PropTypes.object,
        isLoading: PropTypes.bool,
        shouldShowSubmit: PropTypes.bool,
        disabled: PropTypes.bool,
        showSubmit: PropTypes.func,
        className: PropTypes.string,
    };

    handleClick() {
        if (this.props.shouldShowSubmit) {
            // already active
            return;
        }

        scrollTo(0, 0);
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        this.props.showSubmit();
    }

    render() {
        const { isLoading, disabled, classname } = this.props;

        return (
            <SubmitButton
                classname={classname}
                disabled={isLoading || disabled}
                onClick={::this.handleClick}
            />
        );
    }
}

export default connect(
    (state) => ({
        isLoading: getIsSubmitting(state.booking) || getIsSavingDraft(state.booking),
        //shouldShowSubmit: getShowSubmit(state.booking),
    }),
    (dispatch) => bindActionCreators({ showSubmit }, dispatch)
)(SubmitButtonContainer);
